const { Form } = require("react-bootstrap");

const CheckboxField = ({
  isChecked,
  label,
  value,
  name,
  handleChange,
  customClass,
}) => {
  return (
    <Form.Check
      className={`${customClass}`}
      type="checkbox"
      name={name}
      value={value}
      checked={isChecked}
      onChange={(e)=>handleChange(e)}
      label={label}
    />
  );
};

export default CheckboxField;
